const initialState = {
    hasActiveSubscription: false,
    teamBilling: null,
    seatSubscriptions: [],
    subscriptionDetails: {
        data: null,
        lastFetched: null,
        isLoading: false,

    },
    creditDetails: {
        data: null,
        lastFetched: null,
        isLoading: false,
    },
    subscriptionPlan: [],
    creditPlans:[],
    audioEngineerPlans:[],
    lastSubscriptionFetched: null,
    purchaseData:{},
    purchaseDataByMonth:{},
    purchaseDataByMonthForROI:{},
    purchaseDataByDuration:{}
};

const billingReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GETBILLINGSTATUS':
            return {
                ...state,
                hasActiveSubscription: action.hasActiveSubscription,
                teamBilling: action.teamBilling ?? null,
                seatSubscriptions: action.seatSubscriptions ?? [],
                subscriptionDetails: {
                    data: action.subscriptionDetails,
                    lastFetched: Date.now(),
                    isLoading: false,
                    error: null
                },
                creditDetails: {
                    data: action.creditDetails,
                    lastFetched: Date.now(),
                    isLoading: false,
                    error: null
                }
            };
        case 'GETSUBSCRIPTIONLIST':
            return {
                ...state,
                subscriptionPlan: action.list,
                lastSubscriptionFetched: Date.now(),
                ...(action.teamBilling != null ? { teamBilling: action.teamBilling } : {}),
            };
        case 'GETCREDITPLANLIST':
            return {
                ...state,
                creditPlans: action.list
            };
        case 'GETAUDIOENGINEERPLAN':
            return {
                ...state,
                audioEngineerPlans: action.list
            };          
        case 'GETCREDITDETAILS':
            return {
                ...state,
                creditDetails: {
                    data: action.creditDetails,
                    lastFetched: Date.now(),
                    isLoading: false,
                    error: null
                }
            };    
            case 'PURCHASEDATA':
                return {
                    ...state,
                    purchaseData: action.purchaseData
                };
            case 'PURCHASEBYMONTH':
                return {
                    ...state,
                    purchaseByMonth: action.purchaseByMonth
                };
            case 'PURCHASEBYMONTHFORROI':
                return {
                    ...state,
                    purchaseByMonthForROI: action.purchaseByMonthForROI
                };
            case 'PURCHASEBYDURATION':
                return {
                    ...state,
                    purchaseByDuration: action.purchaseByDuration
                };
        default:
            return state;
    }
};

export default billingReducer;